export default __webpack_public_path__ + "static/media/AcornOffice_42.a3ee353b.png";